import { render } from "./MyPoint.vue?vue&type=template&id=175fd13e"
import script from "./MyPoint.vue?vue&type=script&lang=js"
export * from "./MyPoint.vue?vue&type=script&lang=js"

import "./MyPoint.vue?vue&type=style&index=0&id=175fd13e&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__